// File Metadata:
// Filename: EditVendor.js
// Version: 1.00
// Created: 2022-10-13 22:59:28
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useParams } from 'react-router-dom'
import EditVendorForm from './EditVendorForm'
import { useGetVendorsQuery } from '../api/vendorsApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'

const EditVendor = () => {
	const { id } = useParams()
	const { isVoorman, isAdmin } = useAuth()

	const { vendor } = useGetVendorsQuery('vendorsList', {
		selectFromResult: ({ data }) => ({
			vendor: data?.entities[id]
		})
	})

	if (!vendor) return <PulseLoader color='#fff' />

	if (!isVoorman && !isAdmin) {
		return <p className='errmsg'>No access</p>
	}
	const content = <EditVendorForm vendor={vendor} />

	return content
}

export default EditVendor
